import Image from "next/image";

const AuthInputs = ({
  label,
  value,
  setValue,
  type,
  imageURL,
  imageAlt,
  htmlFor,
  placeholder,
  error,
}) => {
  return (
    <div className="auth__inputContainer inputContainer">
      <label htmlFor={htmlFor} className="auth__inputLabel inputLabel">
        {label}
      </label>
      <div className="auth__inputIcon">
        <Image src={imageURL} alt={imageAlt} height="24" width="24" />
      </div>
      <input
        id={htmlFor}
        className={`auth__input auth_input${error ? " auth__input--error" : ""}`}
        type={type}
        value={value ?? ""}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        autoComplete="on"
        aria-invalid={error ? "true" : "false"}
        aria-describedby={error ? `${htmlFor}-error` : undefined}
      />
      {error ? (
        <p id={`${htmlFor}-error`} className="auth__fieldError" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default AuthInputs;
